// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explorer-homeTap {
  height: 100%;
}
.explorer-homeTap .homeTap-header {
  font-size: 10px;
  font-family: "Open Sans", sans-serif;
  padding: 4px 8px;
  -webkit-user-select: none;
          user-select: none;
}
.explorer-homeTap .homeTap-content {
  height: calc(100% - 19px);
  display: flex;
  flex-direction: column;
  color: #b8b8b8;
}
.explorer-homeTap .homeTap-content .content-tapItemOpen {
  height: 100%;
}
.explorer-homeTap .homeTap-content .content-tapItem .tapItem-headerActive {
  cursor: pointer;
}
.explorer-homeTap .homeTap-content .content-tapItem .tapItem-header {
  display: flex;
  gap: 2px;
  flex-direction: row;
  flex-wrap: nowrap;
  border-top: 1px solid var(--color-navLeft-border);
  -webkit-user-select: none;
          user-select: none;
  text-transform: uppercase;
}
.explorer-homeTap .homeTap-content .content-tapItem .tapItem-header .header-icon {
  font-size: 13px;
}
.explorer-homeTap .homeTap-content .content-tapItem .tapItem-header .header-title {
  font-family: Ubuntu-M, sans-serif;
  font-size: 12px;
}
.explorer-homeTap .homeTap-content .content-tapItem .tapItem-content {
  height: 0;
  overflow: hidden;
}
.explorer-homeTap .homeTap-content .content-tapItem .tapItemOpen {
  height: 100%;
}
.explorer-homeTap .homeTap-content .content-tapItem:last-child .tapItem-header {
  border-bottom: 1px solid var(--color-navLeft-border);
}`, "",{"version":3,"sources":["webpack://./src/components/explorer/taps/homeTap.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AACJ;AAEE;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAIM;EACE,eAAA;AAFR;AAKM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,iDAAA;EAEA,yBAAA;UAAA,iBAAA;EACA,yBAAA;AAJR;AAMQ;EACE,eAAA;AAJV;AAOQ;EACE,iCAAA;EACA,eAAA;AALV;AASM;EACE,SAAA;EACA,gBAAA;AAPR;AAUM;EACE,YAAA;AARR;AAaM;EACE,oDAAA;AAXR","sourcesContent":[".explorer-homeTap {\n  height: 100%;\n\n  .homeTap-header {\n    font-size: 10px;\n    font-family: 'Open Sans', sans-serif; \n    padding: 4px 8px;\n    user-select: none;\n  }\n\n  .homeTap-content {\n    height: calc(100% - 19px);\n    display: flex;\n    flex-direction: column;\n    color: #b8b8b8;\n\n    .content-tapItemOpen {\n      height: 100%;\n    }\n\n    .content-tapItem {\n      .tapItem-headerActive {\n        cursor: pointer;\n      }\n\n      .tapItem-header {\n        display: flex;\n        gap: 2px;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        border-top: 1px solid var(--color-navLeft-border);\n      \n        user-select: none;\n        text-transform: uppercase;\n\n        .header-icon {\n          font-size: 13px;\n        }\n\n        .header-title {\n          font-family: Ubuntu-M, sans-serif;\n          font-size: 12px;\n        }\n      }\n\n      .tapItem-content {\n        height: 0;\n        overflow: hidden;\n      }\n\n      .tapItemOpen {\n        height: 100%;\n      }\n    }\n\n    .content-tapItem:last-child {\n      .tapItem-header {\n        border-bottom: 1px solid var(--color-navLeft-border);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
